import React from "react";
import nextId from "react-id-generator";
import { useParams } from "react-router";
import Loading from "../../loading/Loading";
import { getDataFromHash } from "../../services/getAPIs";
import Transaction from "../Transaction/Transaction";
import moment from "moment-timezone";

export default function TransactionOverview() {
  const { hash } = useParams();

  const [transactionDetails, setTransactionDetails] = React.useState(null);
  const [loading, setLoading] = React.useState(true);

  const setUpDetails = async () => {
    let res;
    try {
      res = await getDataFromHash(hash);
      if (res.data.success) {
        setTransactionDetails(res.data.data);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };
  React.useEffect(() => {
    setUpDetails();
  }, []);
  return loading ? (
    <Loading />
  ) : !transactionDetails ? (
    <div>Something Went Wrong</div>
  ) : (
    <div className="transaction-overview">
      {listOfData.map((obj) => (
        <div className="t-o-row">
          <p key={obj.keyId}>{obj.title}:</p>
          <p>
            {obj.id === "timeStamp"
              ? moment(transactionDetails[obj.id]).format("DD-MM-YYYY hh:mm a")
              : transactionDetails[obj.id]}
          </p>
        </div>
      ))}
    </div>
  );
}
const listOfData = [
  { keyId: nextId(), title: "Transaction Hash", id: "hash" },
  { keyId: nextId(), title: "Status", id: "status" },
  { keyId: nextId(), title: "Timestamp", id: "timeStamp" },
  { keyId: nextId(), title: "Value", id: "data" },
  { keyId: nextId(), title: "By", id: "previousHash" },
  { keyId: nextId(), title: "Time Required", id: "timeRequired" },
  { keyId: nextId(), title: "Merkle Root", id: "merkleRoot" },
];
